import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SurveyModule } from 'survey-angular-ui';
import { MembershipApplicationService } from './membership-application/membership-application.service';
import { DlTransferService } from './dl-transfer/dl-transfer.service';
import { ChangeBrokerageService } from './change-brokerage/change-brokerage.service';
import { TransitionElectionService } from './transition-election/transition-election.service';
import { AffiliateApplicationService } from './affiliate-application/affiliate-application.service';
import { NonMemberService } from './non-member/non-member.service';
import { BranchOfficeService } from './branch-office/branch-office.service';
import { LfroOfficeService } from './lfro-office/lfro-office.service';
import { StaffApplicationService } from './staff-application/staff-application.service';
import { NvtVendorService } from './nvt-vendor/nvt-vendor.service';

const services = {
  'membership-application': MembershipApplicationService,
  'dl-transfer': DlTransferService,
  'change-brokerage': ChangeBrokerageService,
  'transition-election': TransitionElectionService,
  'affiliate-application': AffiliateApplicationService,
  'non-member': NonMemberService,
  'branch-office': BranchOfficeService,
  'lfro-office': LfroOfficeService,
  'staff-application': StaffApplicationService,
  'nvt-vendor': NvtVendorService
};

@NgModule({
  imports: [
    CommonModule,
    SurveyModule,
  ],
  providers: [{provide: MembershipApplicationService}]
})
export class ComplexFormsModule {
  static getService(serviceClassKey: string) {
    for (const key in services) {
      if (key === serviceClassKey) {
        // @ts-ignore
        return services[key];
      }
    }
  }
}
